// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"296":"3d8c6d76","530":"74b893e7","585":"59591bdf"}[chunkId] + ".js";
};